var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.29706 3.56532C0.992685 3.3049 0.508007 3.31271 0.214498 3.58277C-0.0790112 3.85283 -0.0702049 4.28286 0.234167 4.54328L5 8.6209L9.76583 4.54328C10.0702 4.28286 10.079 3.85283 9.7855 3.58277C9.49199 3.31271 9.00731 3.3049 8.70294 3.56532L5 6.73353L1.29706 3.56532Z",
    fill: "#1E6978"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00156 3.25541L7.859 0.810761C8.16234 0.551229 8.64625 0.55903 8.9387 0.828116C9.22997 1.09611 9.22125 1.52212 8.91914 1.7806L5.10647 5.0427L4.89665 5.0427L1.08398 1.7806C0.781879 1.52212 0.773155 1.09611 1.06442 0.828116C1.35688 0.559029 1.84078 0.551228 2.14412 0.810761L5.00156 3.25541Z",
    fill: "#1E6978"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.c04b2932dca0957d073ad4e55745cbfa.svg";
export { ForwardRef as ReactComponent };